import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';

// Cargar documento
export async function addDocument({state, commit}) {

    let form_data = new FormData();

    form_data.append('year', state.data.year);
    form_data.append('file', state.data.file);

    commit('setPreloader', true);

    await $http.post('/api/presupuesto-ventas-clientes', form_data)
        .then((response) => {
            commit('setPreloader', false);

            let errors = response.data.errors;

            if (!errors.length) {
                Notification.success({
                    title: 'Éxito',
                    message: 'Presupuesto cargado exitosamente',
                    type: 'success',
                    duration: 5000,
                    customClass: 'notification-box',
                });
            } else {
                Notification.error({
                    title: 'Error',
                    message: 'Existen inconsistencias en el archivo cargado',
                    type: 'error',
                    duration: 5000,
                    customClass: 'notification-box',
                });

                errors.unshift({errores: 'errores'});
                let csv = '';
// Loop the array of objects
                for (let row = 0; row < errors.length; row++) {
                    let keysAmount = Object.keys(errors[row]).length;
                    let keysCounter = 0;

                    if (row === 0) {

                        for (let key in errors[row]) {

                            csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    } else {
                        for (let key in errors[row]) {
                            csv += errors[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    }

                    keysCounter = 0;
                }

                let link = document.createElement('a');
                link.id = 'download-csv';
                link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                link.setAttribute('download', 'errores.csv');
                document.body.appendChild(link);
                document.querySelector('#download-csv').click();
            }

            commit('resetData');
        })
        .catch((error) => {
            commit('setPreloader', false);

            let message;

            if (error.response.status === 422) {
                message = 'Algunos campos no se registraron correctamente';
            } else {
                message = error.message;
            }

            MessageBox.alert(message, 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            });
        });
}

/**
 * Descargar plantilla
 */
export async function downloadTemplate({}) {
    await $http({
        url: '/api/descargar-plantilla-presupuesto-clientes',
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Plantilla cargue presupuesto por cliente.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

export async function getSalesBudget({commit, state}, contact_warehouse_id) {

    let params = {contact_warehouse_id};

    await $http.get('/api/presupuesto-ventas-clientes', {params})
        .then(async (response) => {

            if (response.data.data[0]){
                commit('setSalesBudget', response.data.data[0]);
            }

        }).catch((error) => {
            console.error(error);
        });
}




// WEBPACK FOOTER //
// ./src/modules/sales_budget_by_contacts_warehouses/actions.js